import { profileUser, bonusHistory } from '@/mocks/profile';

const ProfileBonus = () => {
  const user = profileUser;
  const color = '#f0ff00';
  const progress = Math.min((user.bonusPoints / user.nextLevelPoints) * 100, 100);

  return (
    <div>
      <h2 className="font-orbitron font-black text-xl text-white mb-6">БОНУСНАЯ КАРТА</h2>

      {/* Virtual card */}
      <div
        className="relative rounded-2xl p-6 mb-6 overflow-hidden"
        style={{ background: 'linear-gradient(135deg, #1a1500 0%, #2d2200 50%, #1a1500 100%)', border: `1px solid ${color}40`, boxShadow: `0 0 40px ${color}15` }}
      >
        <div className="absolute top-0 right-0 w-48 h-48 rounded-full opacity-10" style={{ background: color, filter: 'blur(50px)', transform: 'translate(30%, -30%)' }} />
        <div className="absolute bottom-0 left-0 w-32 h-32 rounded-full opacity-8" style={{ background: '#ff6b00', filter: 'blur(40px)', transform: 'translate(-30%, 30%)' }} />

        <div className="relative z-10">
          <div className="flex items-start justify-between mb-8">
            <div>
              <div className="font-orbitron font-black text-xs tracking-widest mb-1" style={{ color }}>NEON PHARMA</div>
              <div className="font-mono text-[10px] text-white/30">БОНУСНАЯ КАРТА</div>
            </div>
            <div className="flex items-center gap-2">
              <div className="px-3 py-1 rounded-full font-orbitron font-black text-xs" style={{ background: color, color: '#050508' }}>
                {user.level}
              </div>
              <i className="ri-vip-crown-fill text-xl" style={{ color }} />
            </div>
          </div>

          <div className="mb-6">
            <div className="font-mono text-[10px] text-white/30 mb-1">БАЛАНС БАЛЛОВ</div>
            <div className="font-orbitron font-black text-4xl" style={{ color, textShadow: `0 0 20px ${color}80` }}>
              {user.bonusPoints.toLocaleString()}
            </div>
            <div className="font-mono text-xs text-white/40 mt-1">= {user.bonusPoints.toLocaleString()} ₽ скидки</div>
          </div>

          <div className="flex items-end justify-between">
            <div>
              <div className="font-mono text-[10px] text-white/30 mb-0.5">ВЛАДЕЛЕЦ</div>
              <div className="font-mono text-sm text-white/80">{user.name}</div>
            </div>
            <div className="text-right">
              <div className="font-mono text-[10px] text-white/30 mb-0.5">КЭШБЭК</div>
              <div className="font-orbitron font-bold text-lg" style={{ color }}>{user.cashbackRate}%</div>
            </div>
          </div>
        </div>
      </div>

      {/* Progress to next level */}
      <div className="rounded-2xl p-5 mb-6" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)' }}>
        <div className="flex items-center justify-between mb-3">
          <div>
            <div className="font-orbitron font-bold text-sm text-white">Прогресс до PLATINUM</div>
            <div className="font-mono text-xs text-white/35 mt-0.5">Осталось {(user.nextLevelPoints - user.bonusPoints).toLocaleString()} баллов</div>
          </div>
          <div className="text-right">
            <div className="font-orbitron font-bold text-lg" style={{ color }}>{user.bonusPoints.toLocaleString()}</div>
            <div className="font-mono text-[10px] text-white/30">из {user.nextLevelPoints.toLocaleString()}</div>
          </div>
        </div>
        <div className="h-3 rounded-full overflow-hidden" style={{ background: 'rgba(255,255,255,0.06)' }}>
          <div
            className="h-full rounded-full transition-all duration-700"
            style={{ width: `${progress}%`, background: `linear-gradient(90deg, ${color}, #ff6b00)`, boxShadow: `0 0 10px ${color}` }}
          />
        </div>
        <div className="flex justify-between font-mono text-[10px] text-white/25 mt-1.5">
          <span>GOLD</span>
          <span>PLATINUM</span>
        </div>
      </div>

      {/* Benefits grid */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-6">
        {[
          { icon: 'ri-coins-line', label: 'Кэшбэк', value: `${user.cashbackRate}%`, color: '#f0ff00' },
          { icon: 'ri-percent-line', label: 'Оплата баллами', value: 'до 99%', color: '#39ff14' },
          { icon: 'ri-cake-line', label: 'День рождения', value: '150 б.', color: '#ff2d78' },
          { icon: 'ri-smartphone-line', label: 'Через приложение', value: '+5%', color: '#00f5ff' },
        ].map((b, i) => (
          <div key={i} className="flex flex-col items-center p-4 rounded-xl text-center" style={{ background: `${b.color}08`, border: `1px solid ${b.color}20` }}>
            <div className="w-8 h-8 flex items-center justify-center rounded-lg mb-2" style={{ background: `${b.color}15` }}>
              <i className={b.icon} style={{ color: b.color, fontSize: '16px' }} />
            </div>
            <div className="font-orbitron font-black text-base mb-0.5" style={{ color: b.color }}>{b.value}</div>
            <div className="font-mono text-[10px] text-white/35 leading-snug">{b.label}</div>
          </div>
        ))}
      </div>

      {/* Bonus history */}
      <div>
        <h3 className="font-orbitron font-bold text-sm text-white mb-4">ИСТОРИЯ БАЛЛОВ</h3>
        <div className="rounded-2xl overflow-hidden" style={{ border: '1px solid rgba(255,255,255,0.06)' }}>
          {bonusHistory.map((item, i) => (
            <div
              key={item.id}
              className="flex items-center gap-4 px-5 py-3.5"
              style={{
                background: i % 2 === 0 ? 'rgba(255,255,255,0.01)' : 'rgba(255,255,255,0.025)',
                borderBottom: i < bonusHistory.length - 1 ? '1px solid rgba(255,255,255,0.04)' : 'none',
              }}
            >
              <div className="w-8 h-8 rounded-xl flex items-center justify-center shrink-0" style={{ background: `${item.color}15`, border: `1px solid ${item.color}25` }}>
                <i className={item.type === 'earned' ? 'ri-add-line' : 'ri-subtract-line'} style={{ color: item.color, fontSize: '14px' }} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-mono text-sm text-white/75 truncate">{item.label}</div>
                <div className="font-mono text-[11px] text-white/30">{item.date}</div>
              </div>
              <div className="font-orbitron font-bold text-base shrink-0" style={{ color: item.color }}>
                {item.amount > 0 ? '+' : ''}{item.amount} б.
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProfileBonus;
